import {Action} from "@ngrx/store";
import {PerformanceHistoryItem} from "../../websites/website/performance/performance-history/performance-history-item";
import {PerformanceTest} from "../../websites/website/performance/performance-test/performance-test";

export const LOAD_PERFORMANCES_HISTORY: string = '[performance] Load Performances History';
export const LOAD_PERFORMANCES_HISTORY_SUCCESS: string = '[performance] Load Performances History success';
export const LOAD_PERFORMANCES_HISTORY_FAIL: string = '[performance] Load Performances History Fail';
export const LOAD_PERFORMANCE_TEST: string = '[performance] Load Performance Test';
export const LOAD_PERFORMANCE_TEST_SUCCESS: string = '[performance] Load Performance Test success';
export const LOAD_PERFORMANCE_TEST_FAIL: string = '[performance] Load Performance Test Fail';
export const RUN_PERFORMANCE_TEST: string = '[performance] Run Performance Test';
export const RUN_PERFORMANCE_TEST_SUCCESS: string = '[performance] Run Performance Test success';
export const RUN_PERFORMANCE_TEST_FAIL: string = '[performance] Run Performance Test Fail';

export class LoadPerformancesHistory implements Action {

  readonly type: string = LOAD_PERFORMANCES_HISTORY;
  constructor(public payload: number) {}

}

export class LoadPerformancesHistorySuccess implements Action {

  readonly type: string = LOAD_PERFORMANCES_HISTORY_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: {[id: string]: PerformanceHistoryItem}
  }) {}

}

export class LoadPerformancesHistoryFail implements Action {

  readonly type: string = LOAD_PERFORMANCES_HISTORY_FAIL;
  constructor(public payload: string) {}

}

export class LoadPerformanceTest implements Action {

  readonly type: string = LOAD_PERFORMANCE_TEST;
  constructor(public payload: {
    websiteId: number,
    performanceTestId: string
  }) {}

}

export class LoadPerformanceTestSuccess implements Action {

  readonly type: string = LOAD_PERFORMANCE_TEST_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    performanceTestId: string,
    performanceTest: PerformanceTest
  }) {}

}

export class LoadPerformanceTestFail implements Action {

  readonly type: string = LOAD_PERFORMANCE_TEST_FAIL;
  constructor(public payload: {
    websiteId: number,
    performanceTestId: string,
    error: string
  }) {}

}

export class RunPerformanceTest implements Action {

  readonly type: string = RUN_PERFORMANCE_TEST;
  constructor(public payload: number, public relativeUrl: string) {}

}

export class RunPerformanceTestSuccess implements Action {

  readonly type: string = RUN_PERFORMANCE_TEST_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    performanceTestId: string,
    performanceTest: PerformanceTest
  }) {}

}

export class RunPerformanceTestFail implements Action {

  readonly type: string = RUN_PERFORMANCE_TEST_FAIL;
  constructor(public payload: {
    websiteId: number,
    error: string
  }) {}

}

export type PerformanceAction = LoadPerformancesHistory | LoadPerformancesHistorySuccess | LoadPerformancesHistoryFail
  | LoadPerformanceTest | LoadPerformanceTestSuccess | LoadPerformanceTestFail
  | RunPerformanceTest | RunPerformanceTestSuccess | RunPerformanceTestFail;
